<a *ngIf="id_store_current !== 'null' && id_store_current !== null">
	<div class="flex flex-col mx-auto sm:w-auto max-w-sm h-full overflow-hidden border-b border-transparent hover:border-gris-medio transition-all duration-1000">
		<div class="relative bg-white bg-cover p-0" style="background-image: url('/assets/images/modal-number-bg.png')">
			
			<div (click)="redirect(product)" class="flex-none w-full relative cursor-pointer focus:outline-none bg-transparent group" style="aspect-ratio: 1 / 1">
				<!-- <img class="absolute w-full h-full top-0 left-0 object-cover" *ngIf="!product.images || product.images.length == 0" [src]="product.variants[0].images.length > 0 ? product.variants[0].images[0].url : default_image  " alt="{{product.variants[0].name}}"> -->
				<!-- <img class="absolute w-full h-full top-0 left-0 object-cover" *ngIf="product.images && product.images.length > 0"
                [src]="product.images[0].url" alt="{{product.variants[0].name}}"> -->
				<img
					[src]="product.variants[0].images.length > 0 ? product.variants[0].images[0].url : product.images.length > 0 ? product.images[0].url : default_image"
					[alt]="product.name"
					class="absolute w-full h-full top-0 left-0 object-cover z-10 group-hover:opacity-0 opacity-100 transition-opacity ease-in-out duration-1000"
				/>
				<img
					*ngIf="product.variants[0].images.length > 1 || product.images.length > 1"
					[src]="product.variants[0].images.length > 1 ? product.variants[0].images[1].url : product.images[1].url"
					[alt]="product.name"
					class="absolute w-full h-full top-0 left-0 z-20 object-cover opacity-0 group-hover:opacity-100 transition-opacity ease-in-out duration-1000"
				/>
				<!-- <img
					[src]="product.images.length > 0 ? product.images[0].url : default_image"
					[alt]="product.name"
					class="absolute w-full h-full top-0 left-0 object-cover z-10 group-hover:opacity-0 opacity-100 transition-opacity ease-in-out duration-1000"
				/>
				<img
					*ngIf="product.images.length > 1"
					[src]="product.images[1].url"
					[alt]="product.name"
					class="absolute w-full h-full top-0 left-0 z-20 object-cover opacity-0 group-hover:opacity-100 transition-opacity ease-in-out duration-1000"
				/> -->
				<!--  -->

				<div *ngIf="promoActive" class="absolute transform rotate-90 top-9 mt-1.5 -right-7 w-28">
					<div class="bg-principal font-medium text-white text-sm px-2 py-1 uppercase w-24">{{ promotionInfo.name }}</div>
				</div>
				<!-- <div class="absolute top-0 left-0 ml-2 mt-4" *ngIf="logoProduct != ''">
                    <img [src]="logoProduct" alt="Logo" class="w-24 h-auto"/>
                </div> -->
			</div>
		</div>
		<!-- titulo y sintesis content -->
		<div class="my-2 flex-1 md:my-6 gap-y-8 h-full">
			<!-- <h2 class="text-sm font-medium pb-3">{{ nameProduct }}</h2> -->
			<!-- <p class="leading-4 text-xs text-principal py-3">{{product.variants[0].subtitle}}</p> -->
			<!-- <p *ngIf="tagsList.length > 0" class="leading-4 text-xs text-principal"> -->
				<!-- Purity / Cold / Clean -->
				<!-- <span *ngFor="let tag of tagsList; let i = index">{{ tag }} <span *ngIf="i < tagsList.length - 1"> / </span></span>
			</p> -->
            <h2 (click)="redirect(product)" class="cursor-pointer md:pt-2 pb-2 md:pb-4 font-semibold text-sm lg:text-base leading-5">{{ product.variants[0].name }}</h2>
			<!-- <p class="text-gris-medio leading-4 truncate w-full text-sm h-4 overflow-hidden">{{product.variants[0].subtitle}}</p> -->
			<div class="text-gris-medio leading-4 truncate w-full text-sm h-4 overflow-hidden" [innerHTML]="processHTML(product.variants[0].subtitle)"></div>
			<ng-container *ngIf="tagsList.length > 0">
				<p class="leading-4 text-xs text-principal py-2">
					<span *ngFor="let tag of tagsList; let i = index">{{ tag }} <span *ngIf="i < tagsList.length - 1"> / </span></span>
				</p>
			</ng-container>
		</div>
		<!-- <div class="flex flex-col md:flex-row mb-6 mt-3 gap-y-2 md:items-center justify-between">
			<div *ngIf="product.variants.length >= 1" class="flex font-medium">
				<p>{{ product.variants[0].sale_price > 0 ? (product.variants[0].sale_price | currencyPersonalized) : (product.variants[0].price | currencyPersonalized) }}</p>
			</div>
			<div class="flex flex-wrap gap-6 md:gap-2 items-stretch" [ngClass]="{ 'w-3/4 ': product.variants.length > 1 }">
				<button (click)="addToCart()" class="text-center md:px-3 text-principal hover:underline focus:underline focus:outline-none whitespace-nowrap" *ngIf="product.variants.length == 1">
					{{ 'buttons.agregarCarrito' | translate }}
				</button>
				<button
					*ngIf="product.variants.length == 1 && hideBtnBuyNow == false"
					(click)="buyNow = true; addToCart()"
					class="text-center md:px-3 text-principal hover:underline focus:underline focus:outline-none whitespace-nowrap"
				>
					{{ 'buttons.comprarAhora' | translate }}
				</button>
			</div>
		</div> -->
		<div class="flex flex-col lg:flex-row w-full h-full justify-center md:justify-start lg:justify-end px-4 md:px-0 items-center md:gap-y-2 lg:gap-y-0 md:mt-2 lg:mt-0 pb-6">
			<!-- <p class="md:w-full lg:w-2/4 text-base lg:text-lg font-bold leading-6 md:text-center lg:text-left">
				{{ product.variants[0].price === 0 ? '' : (product.variants[0].price | currencyPersonalized) }}
			</p>

			<p class="md:w-full lg:w-2/4 text-base lg:text-lg font-bold leading-6 md:text-center lg:text-left">
				{{ product.variants[0].sale_price > 0 ?  (product.variants[0].sale_price | currencyPersonalized) : null}}
			</p> -->
			<div class="flex flex-col md:w-full lg:w-2/4">
				<p *ngIf="product.variants[0].sale_price > 0" class="text-gris-claro text-base font-bold leading-6 md:text-center lg:text-left line-through whitespace-nowrap">
					{{ product.variants[0].price | currencyPersonalized }}
				</p>
				<p class="text-base lg:text-lg font-bold leading-6 md:text-center lg:text-left whitespace-nowrap">
					{{ product.variants[0].sale_price > 0 ? (product.variants[0].sale_price  | currencyPersonalized) : (product.variants[0].price | currencyPersonalized) }}
				</p>
			</div>
			<ng-container *ngIf="!isFullyOutOfStock">
				<button (click)="addToCart()" class="w-full md:w-full lg:w-2/3 py-2 lg:mr-2 my-1 text-center text-gris-medio bg-gris-claro rounded-full hover:bg-gris-medio hover:text-gris-claro transition-all duration-300 text-sm">
					Add to Cart
				</button>
				<button *ngIf="hideBtnBuyNow == false" (click)="buyNow = true; addToCart()" class="w-full md:w-full lg:w-2/3 py-2 mb-1 lg:mb-0 sm:mb-0 text-center text-white bg-principal rounded-full hover:bg-principal-hover transition-all duration-300 text-base">
					Buy Now
				</button>
			</ng-container>
			<div
				*ngIf="isFullyOutOfStock"
				class="w-full md:w-full lg:w-2/3 flex flex-row items-center justify-center gap-2 py-2 my-1 text-center bg-principal-claro text-white border-2 border-principal rounded-full text-sm lg:text-base"
			>
				<p>{{ 'alerts.noStock' | translate }}</p>
				<span class="material-icons-outlined text-lg">shopping_bag</span>
			</div>
		</div>
	</div>
</a>
